/* Ten Antennas — Our Story: sitting the values inside the photograph.

   A FIXED OFFSET CANNOT WORK HERE, which is why this is a script. The banner
   is sized by ratio, so its height follows the window width; the values block
   follows the copy and the column count. A number that looked right at 1050px
   left the text below the image at 2560px — white on white. Both heights are
   measured instead.

   THE ARITHMETIC, stated because the first version got it wrong by exactly the
   distance between two elements. The section is pulled up from where it
   naturally sits, which is directly under the BANNER SECTION — not under the
   image. Between the image's bottom edge and the section's natural top there
   is the banner section's own remaining height plus the margin between
   sections. Pulling by only the block's height therefore left it overhanging
   the crop by that difference — measured at 63px.

   So the offset is derived from the two boxes directly: take the distance from
   the section's current top to where its top SHOULD be, and shift by that.
   Target top = image bottom − block height − gap. Reading positions rather
   than guessing heights makes it correct at any width and any copy length.

   A CEILING keeps the text from covering more than 60% of the picture — past
   that it stops being a photograph with a caption and becomes a text panel
   with a background.

   IDEMPOTENT: written only when the value changes. An earlier script here
   wrote on every mutation, matched its own output and looped at frame rate,
   freezing every page. */
(function () {
  if (window.__taOurStory) return;
  window.__taOurStory = true;

  var GAP = 56;
  var MAX_COVER = 0.6;
  var MIN_WIDTH = 990;

  function scope() {
    return document.documentElement.classList.contains('ta-page-our-story');
  }

  function apply() {
    if (!scope()) return;

    var media = document.querySelector('#MainContent .banner__media');
    var multi = document.querySelector('#MainContent .multicolumn');
    var section = multi ? multi.closest('.shopify-section') : null;
    if (!media || !section) return;

    if (window.innerWidth < MIN_WIDTH) {
      section.classList.remove('ta-values-over');
      if (section.style.marginTop) section.style.marginTop = '';
      return;
    }

    section.classList.add('ta-values-over');

    /* Measure with the offset cleared, so both boxes are in natural position. */
    var previous = section.style.marginTop;
    section.style.marginTop = '0px';

    var imageBottom = media.getBoundingClientRect().bottom;
    var imageHeight = media.getBoundingClientRect().height;
    var box = section.getBoundingClientRect();
    var naturalTop = box.top;
    var blockHeight = box.height;

    /* Where the block's top has to be for its bottom to clear the crop. */
    var targetTop = imageBottom - blockHeight - GAP;

    /* Do not let it climb past the ceiling. */
    var highestAllowed = imageBottom - imageHeight * MAX_COVER;
    if (targetTop < highestAllowed) targetTop = highestAllowed;

    var shift = Math.round(targetTop - naturalTop);
    var value = shift + 'px';

    section.style.marginTop = value;
    if (section.style.marginTop !== value) section.style.marginTop = value;
    if (previous === value) return;
  }

  function boot() {
    apply();
    /* Web fonts and the photograph both change the numbers once they land. */
    window.addEventListener('load', apply);
    window.addEventListener('resize', apply);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
    var img = document.querySelector('#MainContent .banner__media img');
    if (img && !img.complete) img.addEventListener('load', apply, { once: true });
    setTimeout(apply, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
